import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';

import { IFabricante } from '../models/fabricante.model';

@Injectable()
export class FabricanteService extends EntityService<IFabricante> {
  constructor(protected configService: ConfigService) {
    super(
      {
        urlBackend: configService.backendURL,
        baseEntityEndPoint: 'fabricante'
      }
    );
  }
}
